import React, { useEffect, useState } from 'react';
import MessageWrapper from '../../../tailwind_clearstep/ConversationMessage/MessageWrapper';
var ClosingIntakeRemark = function (_a) {
    var conversationId = _a.conversationId;
    var _b = useState(false), _apiCallCompleted = _b[0], setApiCallCompleted = _b[1];
    var _c = useState(false), animationStarted = _c[0], setAnimationStarted = _c[1];
    var progressRemarkText = 'Generating intake summary and care recommendations. This may take a moment to complete...';
    // Start animation immediately on mount
    useEffect(function () {
        setAnimationStarted(true);
    }, []);
    // Handle API call
    useEffect(function () {
        // Immediately call the summary endpoint
        fetch("/intake/conversations/".concat(conversationId, "/summary"), { method: 'GET' })
            .then(function (res) {
            setApiCallCompleted(true);
            if (res.ok) {
                window.location.href = "/intake/".concat(conversationId, "/summary");
            }
            else {
                window.location.reload();
            }
        })
            .catch(function () {
            setApiCallCompleted(true);
            window.location.reload();
        });
    }, [conversationId]);
    return (React.createElement("div", { className: "mb-4" },
        React.createElement(MessageWrapper, null,
            React.createElement("div", { className: "font-normal leading-6" }, progressRemarkText),
            React.createElement("div", { className: "mt-3 h-2 w-full rounded-full bg-gray-200" },
                React.createElement("div", { className: "h-2 rounded-full bg-blue-900 transition-all duration-[10000ms] ease-linear ".concat(animationStarted ? 'w-full' : 'w-0') })))));
};
export default ClosingIntakeRemark;
